module.exports = __webpack_public_path__ + "img/cant-click.59a6a279.png";